/**
 * FikoBirim Dialog — Mühendislik Birim Çevirici
 * Uzunluk/Ağırlık/Alan/Hacim/Basınç/Kuvvet/Sıcaklık/Açı — değer gir, tüm birimlerde gör.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface Kategori { ad: string; birimler: { ad: string; carpan: number }[]; sicaklik?: boolean; }

const KATEGORILER: Kategori[] = [
  { ad: 'Uzunluk', birimler: [{ ad: 'mm', carpan: 1 }, { ad: 'cm', carpan: 10 }, { ad: 'm', carpan: 1000 }, { ad: 'inç', carpan: 25.4 }, { ad: 'ft', carpan: 304.8 }] },
  { ad: 'Ağırlık', birimler: [{ ad: 'g', carpan: 1 }, { ad: 'kg', carpan: 1000 }, { ad: 'ton', carpan: 1e6 }, { ad: 'lb', carpan: 453.592 }, { ad: 'oz', carpan: 28.3495 }] },
  { ad: 'Alan', birimler: [{ ad: 'mm²', carpan: 1 }, { ad: 'cm²', carpan: 100 }, { ad: 'm²', carpan: 1e6 }, { ad: 'inç²', carpan: 645.16 }] },
  { ad: 'Hacim', birimler: [{ ad: 'mm³', carpan: 1 }, { ad: 'cm³', carpan: 1000 }, { ad: 'L', carpan: 1e6 }, { ad: 'm³', carpan: 1e9 }, { ad: 'inç³', carpan: 16387.1 }] },
  { ad: 'Basınç', birimler: [{ ad: 'Pa', carpan: 1 }, { ad: 'kPa', carpan: 1000 }, { ad: 'MPa', carpan: 1e6 }, { ad: 'bar', carpan: 1e5 }, { ad: 'psi', carpan: 6894.76 }, { ad: 'atm', carpan: 101325 }] },
  { ad: 'Kuvvet', birimler: [{ ad: 'N', carpan: 1 }, { ad: 'kN', carpan: 1000 }, { ad: 'kgf', carpan: 9.80665 }, { ad: 'lbf', carpan: 4.44822 }] },
  { ad: 'Tork', birimler: [{ ad: 'N·m', carpan: 1 }, { ad: 'N·cm', carpan: 0.01 }, { ad: 'kgf·m', carpan: 9.80665 }, { ad: 'lbf·ft', carpan: 1.35582 }, { ad: 'lbf·in', carpan: 0.112985 }] },
  { ad: 'Açı', birimler: [{ ad: '°', carpan: 1 }, { ad: 'rad', carpan: 57.29578 }, { ad: 'grad', carpan: 0.9 }] },
  { ad: 'Sıcaklık', sicaklik: true, birimler: [{ ad: '°C', carpan: 1 }, { ad: '°F', carpan: 1 }, { ad: 'K', carpan: 1 }] },
];

@Component({
  selector: 'fikoyt-birim',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="br">
    <div class="br-kat">
      @for (k of kategoriler; track $index) {
        <button class="br-kb" [class.aktif]="katIdx===$index" (click)="katSec($index)">{{ k.ad }}</button>
      }
    </div>
    <div class="br-giris">
      <input type="number" [(ngModel)]="deger" (ngModelChange)="hesapla()" class="br-deger">
      <select [(ngModel)]="kaynakIdx" (ngModelChange)="hesapla()">
        @for (b of kat().birimler; track $index) { <option [ngValue]="$index">{{ b.ad }}</option> }
      </select>
    </div>
    <div class="br-tablo">
      @for (b of kat().birimler; track $index) {
        <div class="br-r" [class.kaynak]="kaynakIdx===$index">
          <span class="br-b">{{ b.ad }}</span>
          <span class="br-v">{{ sonuc[$index] }}</span>
        </div>
      }
    </div>
  </div>
  `,
  styles: [`
    .br { padding:10px; min-width:280px; max-width:320px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .br-kat { display:flex; flex-wrap:wrap; gap:4px; margin-bottom:8px; }
    .br-kb { padding:4px 8px; background:rgba(0,60,80,.6); border:1px solid rgba(0,200,220,.3); color:#bff; border-radius:5px; cursor:pointer; font-size:10px; }
    .br-kb.aktif { background:linear-gradient(90deg,#0a84c0,#0bb39e); color:#fff; border:none; font-weight:600; }
    .br-giris { display:flex; gap:6px; margin-bottom:8px; }
    .br-deger { flex:1; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.4); color:#fff; padding:6px; border-radius:4px; font-size:13px; outline:none; min-width:0; }
    .br-giris select { width:80px; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.4); color:#fff; padding:6px; border-radius:4px; min-width:0; }
    .br-tablo { background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; overflow:hidden; }
    .br-r { display:flex; justify-content:space-between; align-items:center; padding:6px 9px; border-bottom:1px solid rgba(0,200,220,.1); }
    .br-r:last-child { border-bottom:none; }
    .br-r.kaynak { background:rgba(0,200,120,.14); }
    .br-b { color:#9fe8f7; font-weight:600; }
    .br-v { color:#fff; font-family:monospace; font-size:12px; }
  `]
})
export class FikoBirimComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  kategoriler = KATEGORILER;
  katIdx = 0; kaynakIdx = 0; deger = 1;
  sonuc: string[] = [];

  constructor(private cd: ChangeDetectorRef) { this.hesaplaInt(); }

  kat(): Kategori { return this.kategoriler[this.katIdx]; }

  private sicaklikBaz(deger: number, birim: string): number {   // → °C
    if (birim === '°F') return (deger - 32) * 5 / 9;
    if (birim === 'K') return deger - 273.15;
    return deger;
  }
  private sicaklikCevir(c: number, birim: string): number {   // °C →
    if (birim === '°F') return c * 9 / 5 + 32;
    if (birim === 'K') return c + 273.15;
    return c;
  }

  private hesaplaInt(): void {
    const k = this.kat(); const v = +this.deger || 0;
    if (k.sicaklik) {
      const c = this.sicaklikBaz(v, k.birimler[this.kaynakIdx].ad);
      this.sonuc = k.birimler.map(b => this.fmt(this.sicaklikCevir(c, b.ad)));
    } else {
      const baz = v * k.birimler[this.kaynakIdx].carpan;
      this.sonuc = k.birimler.map(b => this.fmt(baz / b.carpan));
    }
  }
  hesapla(): void { this.hesaplaInt(); this.cd.detectChanges(); }
  katSec(i: number): void { this.katIdx = i; this.kaynakIdx = 0; this.hesapla(); }

  private fmt(v: number): string {
    if (!isFinite(v)) return '—';
    const a = Math.abs(v);
    if (a !== 0 && (a < 1e-4 || a >= 1e7)) return v.toExponential(3);
    return v.toLocaleString('tr-TR', { maximumFractionDigits: 4 });
  }
}
